import {
    REQUEST_ERROR    
  } from "../actions";
  
  export const notifyError = (error, history) => ({
    type: REQUEST_ERROR,
    payload: {error, history}
  });